import React, { Fragment } from 'react';
import moment from 'moment';
import i18n from 'src/i18n';
import { ListModel } from 'src/redux/reducers/lists.reducer';
import { renderFileLink } from 'src/views/AuditLog/helpers/renderHelpers';

interface Props {
  folder: ListModel;
}

const SavedFolder: React.FC<Props> = ({ folder }) => {
  return (
    <Fragment>
      <p className="font-weight-bold">
        {i18n.t('auditLog.detailsOfCreatedFolder')}
      </p>

      <table className="table table-sm">
        <tbody>
          <tr>
            <td>
              {i18n.t('common.name')} / {i18n.t('common.slug')}
            </td>
            <td>
              {folder.name} / {folder.slug}
            </td>
          </tr>
          <tr>
            <td>{i18n.t('common.created')}</td>
            <td>{moment(folder.createdAt).format('LLL')}</td>
          </tr>
          <tr>
            <td>{i18n.t('common.description')}</td>
            <td>{folder.description}</td>
          </tr>
          <tr>
            <td>{i18n.t('foldersAndDocuments.imageAttachment')}</td>
            <td>{folder.imageUrl && renderFileLink(folder.imageUrl)}</td>
          </tr>
        </tbody>
      </table>
    </Fragment>
  );
};

export default SavedFolder;
